import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Button/UnstyledButton.tsx
/**
* Unstyled button component. Can be disabled and optionally rendered as an anchor.
* Intended to be wrapped with styles and exported as new button type - eg `IconButton` or `Button`.
*
* Not to be used externally.
*/
var UnstyledButton = forwardRef(function UnstyledButton({ as, children, className, disabled, ...props }, ref) {
	const Component = as || "button";
	const { onClick, onSubmit, onPointerDown, onPointerUp, onKeyDown, onKeyUp, onKeyPress, ...restProps } = props;
	const eventHandlers = disabled ? {} : {
		onClick,
		onSubmit,
		onPointerDown,
		onPointerUp,
		onKeyDown,
		onKeyUp,
		onKeyPress
	};
	return /* @__PURE__ */ jsx(Component, {
		ref,
		className,
		role: as === "a" ? "link" : "button",
		tabIndex: 0,
		"aria-disabled": disabled,
		...restProps,
		...eventHandlers,
		children
	});
});
//#endregion
export { UnstyledButton };

//# sourceMappingURL=UnstyledButton.js.map